module.exports = __webpack_public_path__ + "img/57583E_969788_292920_848474-256px.90c203bb.png";